import { withUtm } from 'utils/utm';
import safeHtml from 'utils/safe-html';

const ResponseQuote = ({
    company: {
        name: companyName,
        expertName,
        expertPosition,
        website: companyWebsite,
        city,
        slug,
        deactivated,
    },
    response: { body },
    alertSlug,
    planType,
}) => {
    // Even a detached div loads <img> and fires its onerror, so the raw body
    // never reaches innerHTML.
    const tmp = document.createElement('div');
    tmp.innerHTML = safeHtml(body);
    body = tmp.innerText.trim();
    tmp.remove();

    // Pro is stored as contributing_editor: plan.type holds Stripe price
    // nicknames, which the Plus/Pro display rename deliberately left alone.
    const tag = (url) =>
        planType === 'contributing_editor' ? withUtm(url, alertSlug) : url;

    if (companyWebsite) {
        companyWebsite = tag(
            companyWebsite.includes('http')
                ? companyWebsite
                : `https://${companyWebsite}`
        );
    } else {
        companyWebsite = null;
    }

    const profileUrl =
        slug && !deactivated ? tag(`${process.env.HOST}/${slug}`) : null;

    const r = (
        <p>
            <b>
                {!profileUrl ? (
                    expertName
                ) : (
                    <a href={profileUrl}>{expertName}</a>
                )}
                , {expertPosition}
            </b>{' '}
            at{' '}
            {!companyWebsite ? (
                <b>
                    {city ? `${city}-based ` : ''}
                    {companyName}
                </b>
            ) : (
                <a href={companyWebsite}>
                    <b>
                        {city ? `${city}-based ` : ''}
                        {companyName}
                    </b>
                </a>
            )}{' '}
            commented:
            <br />
            <br />
            {`"${body}"`}
            <br />
            <br />
        </p>
    );

    return r;
};

export default ResponseQuote;
